import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FilterRequestMecsModel } from 'src/app/models/mecs-models/filter-request-mecs.model';
import { GetMecsGlobalCountriesDataResponseModel } from 'src/app/models/mecs-models/get-mecs-global-countries-data-response.model';
import {
  MapConfig,
  MetricType,
} from 'src/app/models/mecs-models/mecs-map-data.model';
import { HomeService } from 'src/app/services/home.service';
import { TABLE_DISPLAYED_COLUMNS_CONFIGURATION } from 'src/app/submodules/fertility-dashboard/pages/fertility-home-page/configurations/table-displayed-columns-configuration';
import { TABLE_HEADER_ROWS_CONFIGURATION } from 'src/app/submodules/fertility-dashboard/pages/fertility-home-page/configurations/table-header-rows-configuration';
import { TOP_COUNTRIES_COLORS_CONFIGURATION } from 'src/app/submodules/fertility-dashboard/pages/fertility-home-page/configurations/top-countries-colors';
import * as TextConstants from '../../../../constants/text.constants';
import { MecsRegionSolutionLaunchesModel } from 'src/app/models/mecs-models/mecs-region-solution-launches.model';
import { MecsOverviewSolutionCountryPhase } from 'src/app/models/mecs-models/mecs-overview-solution-country-phase.model';
import { Router, ActivatedRoute } from '@angular/router';
import { REGION_MAP_ICON_CONFIGURATION } from 'src/app/submodules/fertility-dashboard/pages/fertility-home-page/configurations/region-configuration';

@Component({
  selector: 'app-mecs-dashboard',
  templateUrl: './mecs-dashboard.component.html',
  styleUrls: ['./mecs-dashboard.component.scss'],
})
export class MecsDashboardComponent implements OnInit {
  textConstants = TextConstants;
  selectedMetricType: MetricType = 'posters';
  regionMapIconsCongig = REGION_MAP_ICON_CONFIGURATION;

  mapConfig: MapConfig = {
    data: [],
    metricType: this.selectedMetricType,
  };

  filterOptions: FilterRequestMecsModel = {
    startDate: null,
    endDate: null,
    countries: [],
    regions: [],
    solutions: [],
    phases: [],
  };

  dataSource: MecsRegionSolutionLaunchesModel[] = [];
  dataSourceCountryPhase: MecsOverviewSolutionCountryPhase[] = [];
  displayedColumnsProjectPhase: string[] = [
    'solutions',
    'planing',
    'pre-launch',
    'launch',
    'on-hold',
  ];

  productHeaders: string[] = [];
  headerRows: string[] = [];
  displayedColumns: string[] = [];

  countriesColors = TOP_COUNTRIES_COLORS_CONFIGURATION;

  showSpinner = false;
  countriesData: GetMecsGlobalCountriesDataResponseModel = {
    implementationStatus: {
      numberOfCountries: 0,
      countriesLaunchPhase: 0,
      countriesPreLaunchPhase: 0,
      overallInternalNPS: 0,
      solutionReuquests: 0,
    },
    topCountries: [],
    globalOverview: [],
  };

  currentPageGlobalOverview = 1;
  itemsPerPageGlobalOverview = 6;

  currentSolutionsLaunchPage = 1;
  itemsPerPageSolutionLaunches = 7;
  totalPagesSolutionLaunches: number = 0;

  @ViewChild('regionCell', { static: false }) regionCellRef!: ElementRef;
  regionFlexBasis: string = '19%';
  columnsFlexBasis: string = '33%';

  constructor(
    private homeService: HomeService,
    private router: Router,
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.showSpinner = true;

    this.getCountriesData();
    this.getOverviewSolutionLaunches();
    this.getOverviewSolutionCountryPhase();
  }

  getOverviewSolutionCountryPhase() {
    this.homeService
      .getMecsOvervewSolutionCountryPhase(this.filterOptions)
      .subscribe((result) => {
        this.dataSourceCountryPhase = result;
      });
  }

  getOverviewSolutionLaunches() {
    this.filterOptions.itemsPerPage = 7;
    this.filterOptions.page = this.currentSolutionsLaunchPage;
    this.homeService
      .getMecsOvervewSolutionLaunches(this.filterOptions)
      .subscribe((result) => {
        this.dataSource = result;

        this.totalPagesSolutionLaunches = Math.ceil(
          result[0].totalProductLaunches / this.itemsPerPageSolutionLaunches
        );

        this.dataSource.forEach((region) => {
          region.regionName = region?.regionName.toUpperCase();

          const iconUrl =
            this.regionMapIconsCongig.find(
              (x) =>
                x.regionName.toLowerCase() === region.regionName.toLowerCase()
            )?.iconUrl ?? null;
          region.iconUrl = iconUrl;
        });
        this.productHeaders = [];
        this.headerRows = [];
        this.displayedColumns = [];
        this.displayedColumns.push('region');
        this.headerRows.push('header-row-region');
        this.dataSource[0].productLaunchesData.forEach((product) => {
          this.productHeaders.push(product.name);

          this.headerRows.push(product.name);
          this.displayedColumns.push(product.name + '-launched');
          this.displayedColumns.push(product.name + '-countries');
        });
        this.showSpinner = false;

        this.updateRegionColumnWidth();
      });
  }

  getProductData(region: any, productName: string) {
    const product = region.productLaunchesData.find(
      (p: any) => p.name === productName
    );

    return {
      launched: product?.launchedCountries || 0,
      total: product?.totalNumberOfCountries || 0,
      topCountries: product?.topCountries?.join(' ') || 'N/A',
    };
  }

  getCountriesData() {
    this.homeService
      .getMecsGlobalCountriesData(this.filterOptions)
      .subscribe((result) => {
        this.countriesData = result;
      });
  }

  getFilterData(e: any) {
    this.filterOptions = e;
    this.getCountriesData();
    this.getOverviewSolutionLaunches();
    this.getOverviewSolutionCountryPhase();
  }

  onRegionClick(region: any) {
    this.router.navigate(['../region/' + region], { relativeTo: this.route });
  }

  get paginatedGlobalOverview() {
    const start =
      (this.currentPageGlobalOverview - 1) * this.itemsPerPageGlobalOverview;
    return this.countriesData.globalOverview.slice(
      start,
      start + this.itemsPerPageGlobalOverview
    );
  }

  get totalPagesGlobalOverview() {
    return Math.ceil(
      this.countriesData.globalOverview.length / this.itemsPerPageGlobalOverview
    );
  }

  get pagesGlobalOverview(): number[] {
    return Array.from(
      { length: this.totalPagesGlobalOverview },
      (_, i) => i + 1
    );
  }

  get pagesSolutionLaunches(): number[] {
    return Array.from(
      { length: this.totalPagesSolutionLaunches },
      (_, i) => i + 1
    );
  }

  goToPageGlobalOverivew(page: number) {
    if (page >= 1 && page <= this.totalPagesGlobalOverview) {
      this.currentPageGlobalOverview = page;
    }
  }

  goToPageSolutionLaunches(page: number) {
    if (page >= 1 && page <= this.totalPagesSolutionLaunches) {
      this.currentSolutionsLaunchPage = page;

      this.getOverviewSolutionLaunches();
    }
  }

  updateRegionColumnWidth() {
    setTimeout(() => {
      if (!this.regionCellRef?.nativeElement) return;

      const regionCell = this.regionCellRef.nativeElement;

      const regionRect = regionCell.getBoundingClientRect();
      const regionWidth = regionRect.width;
      if (regionWidth < 30) {
        return;
      }

      const table = regionCell.closest('mat-table') as HTMLElement;
      const tableRect = table?.getBoundingClientRect();
      const tableWidth = tableRect?.width || window.innerWidth;

      const percentage = (regionWidth / tableWidth) * 100;
      this.regionFlexBasis = `${percentage.toFixed(2)}%`;

      this.columnFlexBasis()
    }, 0);
  }

  columnFlexBasis() {
    const regionWidth = parseFloat(this.regionFlexBasis);
    const count = this.productHeaders.length;
    const remaining = 100 - regionWidth;
    this.columnsFlexBasis = `${(remaining / count).toFixed(2)}%`;
  }

  goToInDepth() {
    this.router.navigate(['../in-depth'], {relativeTo: this.route});
  }
}
